export const DEFAULT =
  'https://d3cdo0emj8d2qc.cloudfront.net/assets/VNd5IQF4R0yRwPykRygK-guOQLuHGYOK.png';

export const images: { [index: number]: string } = {
  2020: 'https://d3cdo0emj8d2qc.cloudfront.net/assets/eUpp60gJTCe65OchCnwd5WHMSUmnLptr.png',
  2021: 'https://d3cdo0emj8d2qc.cloudfront.net/assets/9ihlSB1MTNWPAwCcldC17zXXSsq-QRT8.png',
  2022: 'https://d3cdo0emj8d2qc.cloudfront.net/assets/rwr_OWSIR4KColTVjqmaFS5RQx_xgwG_.png',
};
/**.
 * GetCurrent
 *
 * @returns the current watermark based on the year, falls back to the default watermark (Osmosis.org)
 */
export const getCurrent = (): string =>
  images[new Date().getFullYear()] || DEFAULT;
